import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

const IpsaLayout = ({ children }) => {
    useEffect(() => {
        document.body.id = 'ipsa'
    }, [])

    useEffect(() => {
        return () => {
            document.body.id = null
        }
    }, [])

    return (
        <div id="main-page" className="col-section">
            {children}
        </div>
    )
}

IpsaLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
}

export default IpsaLayout
